import { memo, useContext, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { ConfigContext } from "../../../../../utils/ConfigContext";
import { FISidebar } from "../../../../Icons";
import IconButton from "../../../../UI/Button/IconButton";

import { Tooltip } from "../../../../UI";
import {
  SectionItem,
  SectionItemContainer,
} from "../UI/Section/Section-styled";

const GoSidebarExpand = (props) => {
  return (
    <svg
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="0"
      viewBox="0 0 24 24"
      height="1em"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM9 5V19H20V5H9Z"></path>
    </svg>
  );
};

const SidebarHeader = ({ expanded, toggleSidebar }) => {
  const { t } = useTranslation("common");
  const { config } = useContext(ConfigContext);

  const title = useMemo(() => {
    return t("ops." + config.id + ".title", config.title) || "";
  }, [config, t]);

  return (
    <SectionItemContainer style={{ padding: "0px 8px" }}>
      <SectionItem
        className="onboarding-sidebar-expand"
        style={{ minHeight: 35 }}
        onClick={toggleSidebar}
      >
        {expanded && (
          <>
            <span className="text-elipsis">
              <span
                style={{ fontWeight: 600, fontSize: 14, lineHeight: "normal" }}
              >
                LogIE{" "}
              </span>
              <span>{title}</span>
            </span>
          </>
        )}

        <IconButton
          style={{
            marginLeft: expanded ? "auto" : "",
            display: "flex",
            position: "relative",
          }}
        >
          <Tooltip
            wrapperStyles={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              zIndex: 2,
            }}
            content={
              expanded ? t("screen.sidebar.close") : t("screen.sidebar.open")
            }
            showOnHover={true}
            blurred={true}
            placement="right"
            offset={16}
          />
          {!expanded ? <FISidebar /> : <GoSidebarExpand />}
        </IconButton>
      </SectionItem>
    </SectionItemContainer>
  );
};

export default memo(SidebarHeader);
